import master from "../_ApiConn/apiMaster";


const getMaster = async () => {
    const token = localStorage.getItem('token');
    let dFromF = await master.getMaster(token);
    return (dFromF.data[0]);
}

const updateTheMaster = async (obj) => {
    const token = localStorage.getItem('token');
    let dFromF = await master.updateTheMaster(token, obj);
    return (dFromF);
}


const updateTheMasterByItm = async (itmToGet, obj) => {
    const token = localStorage.getItem('token');
    let dFromF = await master.updateTheMasterByItm(itmToGet, token, obj);
    return (dFromF.data);
}


const getMastersLogo = async () => {
    let dFromF = await master.getMastersLogo();
    return (dFromF.data);
}

export default {

    getMaster,
    updateTheMaster,
    updateTheMasterByItm,
    getMastersLogo
};